function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FlattenedEncrypt } from '../flattened/encrypt.js';
import { unprotected } from '../../lib/private_symbols.js';
import { JOSENotSupported, JWEInvalid } from '../../util/errors.js';
import generateCek from '../../lib/cek.js';
import isDisjoint from '../../lib/is_disjoint.js';
import encryptKeyManagement from '../../lib/encrypt_key_management.js';
import { encode as base64url } from '../../runtime/base64url.js';
import validateCrit from '../../lib/validate_crit.js';
var IndividualRecipient = /*#__PURE__*/function () {
  function IndividualRecipient(enc, key, options) {
    _classCallCheck(this, IndividualRecipient);
    this.parent = enc;
    this.key = key;
    this.options = options;
  }
  return _createClass(IndividualRecipient, [{
    key: "setUnprotectedHeader",
    value: function setUnprotectedHeader(unprotectedHeader) {
      if (this.unprotectedHeader) {
        throw new TypeError('setUnprotectedHeader can only be called once');
      }
      this.unprotectedHeader = unprotectedHeader;
      return this;
    }
  }, {
    key: "addRecipient",
    value: function addRecipient() {
      var _this$parent;
      return (_this$parent = this.parent).addRecipient.apply(_this$parent, arguments);
    }
  }, {
    key: "encrypt",
    value: function encrypt() {
      var _this$parent2;
      return (_this$parent2 = this.parent).encrypt.apply(_this$parent2, arguments);
    }
  }, {
    key: "done",
    value: function done() {
      return this.parent;
    }
  }]);
}();
export var GeneralEncrypt = /*#__PURE__*/function () {
  function GeneralEncrypt(plaintext) {
    _classCallCheck(this, GeneralEncrypt);
    this._recipients = [];
    this._plaintext = plaintext;
  }
  return _createClass(GeneralEncrypt, [{
    key: "addRecipient",
    value: function addRecipient(key, options) {
      var recipient = new IndividualRecipient(this, key, {
        crit: options === null || options === void 0 ? void 0 : options.crit
      });
      this._recipients.push(recipient);
      return recipient;
    }
  }, {
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      if (this._protectedHeader) {
        throw new TypeError('setProtectedHeader can only be called once');
      }
      this._protectedHeader = protectedHeader;
      return this;
    }
  }, {
    key: "setSharedUnprotectedHeader",
    value: function setSharedUnprotectedHeader(sharedUnprotectedHeader) {
      if (this._unprotectedHeader) {
        throw new TypeError('setSharedUnprotectedHeader can only be called once');
      }
      this._unprotectedHeader = sharedUnprotectedHeader;
      return this;
    }
  }, {
    key: "setAdditionalAuthenticatedData",
    value: function setAdditionalAuthenticatedData(aad) {
      this._aad = aad;
      return this;
    }
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$_recipients, recipient, flattened, _jwe, enc, i, _recipient, joseHeader, alg, cek, jwe, _i, _recipient2$unprotect, _this$_protectedHeade, _this$_unprotectedHea, _recipient2, target, _joseHeader, p2c, _flattened, _yield$encryptKeyMana, encryptedKey, parameters;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this._recipients.length) {
                _context.n = 1;
                break;
              }
              throw new JWEInvalid('at least one recipient must be added');
            case 1:
              if (!(this._recipients.length === 1)) {
                _context.n = 3;
                break;
              }
              _this$_recipients = _slicedToArray(this._recipients, 1), recipient = _this$_recipients[0];
              _context.n = 2;
              return new FlattenedEncrypt(this._plaintext).setAdditionalAuthenticatedData(this._aad).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).encrypt(recipient.key, _objectSpread({}, recipient.options));
            case 2:
              flattened = _context.v;
              _jwe = {
                ciphertext: flattened.ciphertext,
                iv: flattened.iv,
                recipients: [{}],
                tag: flattened.tag
              };
              if (flattened.aad) _jwe.aad = flattened.aad;
              if (flattened.protected) _jwe.protected = flattened.protected;
              if (flattened.unprotected) _jwe.unprotected = flattened.unprotected;
              if (flattened.encrypted_key) _jwe.recipients[0].encrypted_key = flattened.encrypted_key;
              if (flattened.header) _jwe.recipients[0].header = flattened.header;
              return _context.a(2, _jwe);
            case 3:
              i = 0;
            case 4:
              if (!(i < this._recipients.length)) {
                _context.n = 12;
                break;
              }
              _recipient = this._recipients[i];
              if (isDisjoint(this._protectedHeader, this._unprotectedHeader, _recipient.unprotectedHeader)) {
                _context.n = 5;
                break;
              }
              throw new JWEInvalid('JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint');
            case 5:
              joseHeader = _objectSpread(_objectSpread(_objectSpread({}, this._protectedHeader), this._unprotectedHeader), _recipient.unprotectedHeader);
              alg = joseHeader.alg;
              if (!(typeof alg !== 'string' || !alg)) {
                _context.n = 6;
                break;
              }
              throw new JWEInvalid('JWE "alg" (Algorithm) Header Parameter missing or invalid');
            case 6:
              if (!(alg === 'dir' || alg === 'ECDH-ES')) {
                _context.n = 7;
                break;
              }
              throw new JWEInvalid('"dir" and "ECDH-ES" alg may only be used with a single recipient');
            case 7:
              if (!(typeof joseHeader.enc !== 'string' || !joseHeader.enc)) {
                _context.n = 8;
                break;
              }
              throw new JWEInvalid('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
            case 8:
              if (enc) {
                _context.n = 9;
                break;
              }
              enc = joseHeader.enc;
              _context.n = 10;
              break;
            case 9:
              if (!(enc !== joseHeader.enc)) {
                _context.n = 10;
                break;
              }
              throw new JWEInvalid('JWE "enc" (Encryption Algorithm) Header Parameter must be the same for all recipients');
            case 10:
              validateCrit(JWEInvalid, new Map(), _recipient.options.crit, this._protectedHeader, joseHeader);
              if (!(joseHeader.zip !== undefined)) {
                _context.n = 11;
                break;
              }
              throw new JOSENotSupported('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
            case 11:
              i++;
              _context.n = 4;
              break;
            case 12:
              cek = generateCek(enc);
              jwe = {
                ciphertext: '',
                iv: '',
                recipients: [],
                tag: ''
              };
              _i = 0;
            case 13:
              if (!(_i < this._recipients.length)) {
                _context.n = 18;
                break;
              }
              _recipient2 = this._recipients[_i];
              target = {};
              jwe.recipients.push(target);
              _joseHeader = _objectSpread(_objectSpread(_objectSpread({}, this._protectedHeader), this._unprotectedHeader), _recipient2.unprotectedHeader);
              p2c = _joseHeader.alg.startsWith('PBES2') ? 2048 + _i : undefined;
              if (!(_i === 0)) {
                _context.n = 15;
                break;
              }
              _context.n = 14;
              return new FlattenedEncrypt(this._plaintext).setAdditionalAuthenticatedData(this._aad).setContentEncryptionKey(cek).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(_recipient2.unprotectedHeader).setKeyManagementParameters({
                p2c: p2c
              }).encrypt(_recipient2.key, _objectSpread(_objectSpread({}, _recipient2.options), {}, _defineProperty({}, unprotected, true)));
            case 14:
              _flattened = _context.v;
              jwe.ciphertext = _flattened.ciphertext;
              jwe.iv = _flattened.iv;
              jwe.tag = _flattened.tag;
              if (_flattened.aad) jwe.aad = _flattened.aad;
              if (_flattened.protected) jwe.protected = _flattened.protected;
              if (_flattened.unprotected) jwe.unprotected = _flattened.unprotected;
              target.encrypted_key = _flattened.encrypted_key;
              if (_flattened.header) target.header = _flattened.header;
              return _context.a(3, 17);
            case 15:
              _context.n = 16;
              return encryptKeyManagement(((_recipient2$unprotect = _recipient2.unprotectedHeader) === null || _recipient2$unprotect === void 0 ? void 0 : _recipient2$unprotect.alg) || ((_this$_protectedHeade = this._protectedHeader) === null || _this$_protectedHeade === void 0 ? void 0 : _this$_protectedHeade.alg) || ((_this$_unprotectedHea = this._unprotectedHeader) === null || _this$_unprotectedHea === void 0 ? void 0 : _this$_unprotectedHea.alg), enc, _recipient2.key, cek, {
                p2c: p2c
              });
            case 16:
              _yield$encryptKeyMana = _context.v;
              encryptedKey = _yield$encryptKeyMana.encryptedKey;
              parameters = _yield$encryptKeyMana.parameters;
              target.encrypted_key = base64url(encryptedKey);
              if (_recipient2.unprotectedHeader || parameters) target.header = _objectSpread(_objectSpread({}, _recipient2.unprotectedHeader), parameters);
            case 17:
              _i++;
              _context.n = 13;
              break;
            case 18:
              return _context.a(2, jwe);
          }
        }, _callee, this);
      }));
      function encrypt() {
        return _encrypt.apply(this, arguments);
      }
      return encrypt;
    }()
  }]);
}();